import {
    GET_DIARIES_LIST_DATA,
    GET_TODO_WEEK_DATA,
    GET_TODO_MONTH_DATA,
    GET_DIARY_LOGS,
    GET_DIARY_DETAIL_REQUEST,
    COMPLETE_DIARY_REQUEST,
    CANCEL_DIARY_REQUEST,
    FETCH_DIARY_INFO,
    GET_SPONSORS_REQUEST,
    CHANGE_DIARY_OWNER_REQUEST,
    UPDATE_CAPTION_TODO_REQUEST,
    CREATE_DIARY_REQUEST,
    UPDATE_DIARY_REQUEST,
    FETCH_DIARY_TAGS
} from './actions/actionConstants';

import AppConstants from '../../config/appConstants';

const mappingObject = {};

mappingObject[CREATE_DIARY_REQUEST] = {
    url: "/diary",
    method: AppConstants.httpMethod.POST
};

mappingObject[GET_DIARIES_LIST_DATA] = {
    url: '/clmtodo',
    method: AppConstants.httpMethod.GET
}

mappingObject[COMPLETE_DIARY_REQUEST] = {
    url: '/diary/update',
    method: AppConstants.httpMethod.PUT
}

// mappingObject[CANCEL_DIARY_REQUEST] = {
//     url: '/diary/update',
//     method: AppConstants.httpMethod.PUT
// };

mappingObject[UPDATE_DIARY_REQUEST] = {
    url: '/diary/update',
    method: AppConstants.httpMethod.PUT
};

mappingObject[FETCH_DIARY_TAGS] = {
    url: "/diary?type=tags&search_term=per",
    method: AppConstants.httpMethod.GET
};


// -------------------
mappingObject[GET_TODO_WEEK_DATA] = {
    url: '/tddv',
    mockdata: 'todoListData.json',
    method: AppConstants.httpMethod.GET
}

mappingObject[GET_TODO_MONTH_DATA] = {
    url: '/tdmv',
    mockdata: 'todoListData.json',
    method: AppConstants.httpMethod.GET
}

mappingObject[GET_DIARY_LOGS] = {
    url: '/gtdhl',
    mockdata: 'gtdhl.json',
    method: AppConstants.httpMethod.GET
}

mappingObject[GET_DIARY_DETAIL_REQUEST] = {
    url: '/diariedetails',
    mockdata: 'dtdo.json',
    method: AppConstants.httpMethod.GET
}

mappingObject[FETCH_DIARY_INFO] = {
    url: '/gtd',
    mockdata: '{status: 200}',
    method: AppConstants.httpMethod.GET
}

mappingObject[GET_SPONSORS_REQUEST] = {
    url: '/gtmk',
    mockdata: 'dtdo.json',
    method: AppConstants.httpMethod.GET
}

mappingObject[CHANGE_DIARY_OWNER_REQUEST] = {
    url: '/Todo/UpdateDiaryOwner',
    mockdata: '{status: 200}',
    method: AppConstants.httpMethod.POST
}

mappingObject[UPDATE_CAPTION_TODO_REQUEST] = {
    url: '/upcaptodo',
    mockdata: '{status: 200}',
    method: AppConstants.httpMethod.POST
}

export default mappingObject;